import Clarity from '@microsoft/clarity';
import { User } from 'firebase/auth';

import { mixpanel } from './mixpanel';

const active = !!import.meta.env.VITE_MIXPANEL_TOKEN;

/**
 * Updates Mixpanel user identification and profile
 * Called when user logs in or user data changes
 */
export const identifyUser = async (user?: User) => {
  if (!active) return;

  if (user != null) {
    // Identify the user
    mixpanel.identify(user.uid);

    // Set user profile properties
    const userProperties: Record<string, any> = {
      $email: user.email,
      $name: user.displayName,
      $created: user.metadata.creationTime,
    };

    // Only set avatar if it exists
    if (user.photoURL) {
      userProperties.$avatar = user.photoURL;
    }

    mixpanel.people.set(userProperties);

    // Set user as super property so it's included in all events
    mixpanel.register({
      user_id: user.uid,
      user_email: user.email,
    });

    // Identify user in Clarity
    try {
      Clarity.identify(
        user.uid,
        undefined,
        undefined,
        user.displayName ?? undefined,
      );
      if (user.email) {
        Clarity.setTag('email', user.email);
      }
    } catch (error) {
      console.error('[ANALYTICS] Failed to identify user in Clarity:', error);
    }
  } else {
    // User logged out - reset mixpanel
    mixpanel.reset();
  }
};
